export default __webpack_public_path__ + "static/media/VeggieFruit_07.4044be38.png";